import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ScopeofServicesComponent.metadata.json5';

import styles from '../Miscellanous.module.scss'
import SubScopeofServicesComponent from '../subcomponents/SubScopeofServices/SubScopeofServicesComponent'
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ScopeofServicesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ScopeofServicesComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        subScopeofServicesComponent: {
            data: modelVM.subScopeofServicesDTO,
            updateWizardData,
            submissionVM,
            CompanyContractDetailsPath: `${pathUpdated}.subScopeofServicesDTO`
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            subScopeofServicesComponent: SubScopeofServicesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={handleValueChange}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ScopeofServicesComponent.propTypes = wizardProps;
export default withRouter(ScopeofServicesComponent);
